var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 35,
    viewBox: "0 0 19 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.762 6.18238C15.8351 6.14708 16.9082 6.17391 17.9842 6.1725H18.4275V0.588118C17.8543 0.530227 17.2542 0.44692 16.6541 0.418681C15.5527 0.369262 14.45 0.314194 13.3472 0.341022C11.6641 0.376322 10.0714 0.785796 8.68063 1.78407C7.08509 2.932 6.20967 4.54307 5.87644 6.44642C5.73806 7.23148 5.70277 8.04478 5.68159 8.84255C5.65052 10.0964 5.67453 11.3488 5.67735 12.6027V13.0714H0.333008V19.3096H5.64629V34.9896H12.1386V19.3336H17.4335C17.7046 17.2594 17.97 15.2049 18.2482 13.0658C17.8232 13.0658 17.4405 13.0658 17.0579 13.0658C15.5527 13.0714 12.0948 13.0658 12.0948 13.0658C12.0948 13.0658 12.1103 9.97355 12.147 8.63216C12.1993 6.79377 13.2893 6.23321 14.762 6.18097V6.18238Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.39499215115eb7c59a267e258fdbde6f.svg";
export { ForwardRef as ReactComponent };